import { useFeatureFlag } from './use-feature-flag';
import { SellerFeatures } from '../../enums/seller-features';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

/**
 * @returns {boolean}
 */
export const useEnableLotTracking = () => {
  const isLotTrackingEnabled = useFeatureFlag(FeatureFlagDeclarations.enableLotTracking);
  const isLotTrackingBillingPlanEnabled = useFeatureFlag(FeatureFlagDeclarations.enableLotTrackingBillingPlan);
  const isSellerFeatureEnabled = useIsSellerFeatureEnabled(SellerFeatures.LotTracking);
  return isLotTrackingEnabled || (isLotTrackingBillingPlanEnabled && isSellerFeatureEnabled);
};
